export interface ChatMessageData {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isStreaming?: boolean;
}

export interface SuggestedAction {
  label: string;
  message: string;
}

export interface MockConfig {
  enabled: boolean;
  responseDelay?: number;
}

export interface ChatLabels {
  title?: string;
  placeholder?: string;
  send?: string;
  close?: string;
  welcome?: string;
  typing?: string;
  fabLabel?: string;
}

export const DEFAULT_CHAT_LABELS: Required<ChatLabels> = {
  title: 'Customer Support',
  placeholder: 'Type a message...',
  send: 'Send',
  close: 'Close chat',
  welcome: 'Hi! How can I help you today?',
  typing: 'Assistant is typing...',
  fabLabel: 'Open chat assistant',
};

export interface ChatWidgetProps {
  onSendMessage: (message: string) => void;
  messages: ChatMessageData[];
  isLoading?: boolean;
  suggestedActions?: SuggestedAction[];
  isOpen?: boolean;
  onToggle?: () => void;
  className?: string;
  mockConfig?: MockConfig;
  labels?: ChatLabels;
  locale?: string;
}
